import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { Auth } from "../../autentication/Auth";

@Injectable()
export class CollectionGuardService implements CanActivate{
	constructor(private router: Router){}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):
	boolean | Observable<boolean> | Promise<boolean> {
		const canActivate = Auth.getInstance().getUser().personType !== 'F';

		if(!canActivate){
			this.router.navigate(['']);
		}

		return canActivate;
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/collection/collection.service.guard.ts